var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpChannel } from '@patsnap/tahiti-core/common/http-channel';
import { EnvConfig } from '@/domains/base/types/env-config.interface';
import { DatasetPatentApiDto } from '../types/dataset-patent-api-dto.interface';
let DatasetPatentApiImpl = class DatasetPatentApiImpl {
    constructor(psHttpChannel, envConfig, datasetPatentApiDto) {
        this.psHttpChannel = psHttpChannel;
        this.envConfig = envConfig;
        this.datasetPatentApiDto = datasetPatentApiDto;
    }
    getDatasetApi(params) {
        const DatasetChannel = Symbol.for('DatasetChannel');
        const fetchChannelDataset = this.psHttpChannel.getChannel(DatasetChannel);
        return fetchChannelDataset.requestAsPromise({
            url: `${this.envConfig.workspaceApiUrlPrefix}/${params.space_id}/folder/${params.folder_id}/patents`,
            method: 'POST',
            transformCode: true,
            data: {
                ...params,
            },
        }).then(({ data }) => {
            return this.datasetPatentApiDto.formatData(data);
        });
    }
    postCommentApi() {
        return Promise.resolve();
    }
    postCustomFieldValueApi() {
        return Promise.resolve();
    }
    postBatchCustomFieldValuesApi() {
        return Promise.resolve();
    }
};
DatasetPatentApiImpl = __decorate([
    injectable(),
    __param(0, inject(PsHttpChannel)),
    __param(1, inject(EnvConfig)),
    __param(2, inject(DatasetPatentApiDto)),
    __metadata("design:paramtypes", [typeof (_a = typeof PsHttpChannel !== "undefined" && PsHttpChannel) === "function" ? _a : Object, typeof (_b = typeof EnvConfig !== "undefined" && EnvConfig) === "function" ? _b : Object, typeof (_c = typeof DatasetPatentApiDto !== "undefined" && DatasetPatentApiDto) === "function" ? _c : Object])
], DatasetPatentApiImpl);
export { DatasetPatentApiImpl };
